import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useAuth } from '../../hooks/useAuth'
import api from '../../Services/api'
import { useSnackbar } from 'notistack'

const AuditLogs = () => {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const { token } = useAuth()
  const { enqueueSnackbar } = useSnackbar()

  const fetchLogs = async () => {
    try {
      setLoading(true)
      const res = await fetch(api.apiUrl(api.API_ENDPOINTS.ADMIN.AUDIT_LOGS), {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      if (res.ok) {
        const data = await res.json()
        setLogs(data)
      } else {
        throw new Error("Erreur de récupération des journaux")
      }
    } catch (err) {
      enqueueSnackbar(err.message, { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchLogs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    { 
      field: 'timestamp', 
      headerName: 'Date / Heure', 
      width: 180,
      valueFormatter: (value) => value ? new Date(value).toLocaleString('fr-FR') : ''
    },
    { field: 'admin_username', headerName: 'Administrateur', width: 150 },
    { field: 'action', headerName: 'Action', flex: 1 },
    { field: 'target', headerName: 'Cible', width: 200 },
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h6" gutterBottom>Journaux d'Audit (Lecture Seule)</Typography>
      <DataGrid
        rows={logs}
        columns={columns}
        autoHeight
        sx={{
          border: 0,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'background.default',
          },
        }}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 20 },
          },
          sorting: {
            sortModel: [{ field: 'timestamp', sort: 'desc' }],
          },
        }}
        pageSizeOptions={[20, 50, 100]}
        loading={loading}
        disableRowSelectionOnClick
      />
    </Box>
  )
}

export default AuditLogs
